import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

import { timeOptions } from '../../../data/OptionValues';

const ContentLoadSelect = (props) => {

  const [loadTime, setContentLoad] = useState(props.loadTime);

  const handleContentLoadChanged = (event) => {
    setContentLoad(event.target.value);
    if (props.onChange) {
      props.onChange({"loadTime": event.target.value});
    } else {
      console.error("ContentLoad changed handler not defined");
    }
  };

  useEffect(() => {
    setContentLoad(props.loadTime);
  }, [props.loadTime]);

  return (
    <TextField 
      select
      onChange={handleContentLoadChanged}
      disabled={props.disabled}
      value={loadTime ?? ''}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      {timeOptions?.sort((t1, t2) => {
        return t1.value < t2.value ? -1 : 1;
      }).map(op => {
        return <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>;
      })}
    </TextField>
  );
};

export default ContentLoadSelect;